export default __webpack_public_path__ + "static/media/pizzas-3.1930c54e.jpg";